import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const logout = apiUrl + "/logout";
const routes = {
  label: "Logout",
  root: logout,
  clear_token: logout + "/clear_token",
};

export const Logout = {
  label: routes.label,
  clear_token: () => postWithToken(routes.clear_token),
};
